// import {
//   Avatar,
//   Box,
//   Card,
//   // Icon,
//   // IconButton,
//   // MenuItem,
//   // Select,
//   styled,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   useTheme,
// } from '@mui/material';
// import { Paragraph } from 'app/components/Typography';

// const CardHeader = styled(Box)(() => ({
//   display: 'flex',
//   paddingLeft: '24px',
//   paddingRight: '24px',
//   marginBottom: '12px',
//   alignItems: 'center',
//   justifyContent: 'space-between',
// }));

// const Title = styled('span')(() => ({
//   fontSize: '1rem',
//   fontWeight: '500',
//   textTransform: 'capitalize',
// }));

// const ProductTable = styled(Table)(() => ({
//   minWidth: 400,
//   whiteSpace: 'pre',
//   '& small': {
//     width: 50,
//     height: 15,
//     borderRadius: 500,
//     boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
//   },
//   '& td': { borderBottom: 'none' },
//   '& td:first-of-type': { paddingLeft: '16px !important' },
// }));

// const Small = styled('small')(({ bgcolor }) => ({
//   width: 50,
//   height: 15,
//   color: '#fff',
//   padding: '2px 8px',
//   borderRadius: '4px',
//   overflow: 'hidden',
//   background: bgcolor,
//   boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)',
// }));

// const TopSellingTable = () => {
//   const { palette } = useTheme();
//   const bgError = palette.error.main;
//   const bgPrimary = palette.primary.main;
//   const bgSecondary = palette.secondary.main;

//   return (
//     <Card elevation={3} sx={{ pt: '20px', mb: 3 }}>
//       <CardHeader>
//         <Title>DevAngles Employees</Title>
//         {/* <Select size="small" defaultValue="this_month"> */}
//           {/* <MenuItem value="this_month">This Month</MenuItem>
//           <MenuItem value="last_month">Last Month</MenuItem> */}
//         {/* </Select> */}
//       </CardHeader>

//       <Box overflow="auto">
//         <ProductTable>
//           <TableHead>
//             <TableRow>
//               <TableCell sx={{ px: 3 }} colSpan={4}>
//                 Name
//               </TableCell>
//               <TableCell sx={{ px: 0 }} colSpan={2}>
//                 Planned Leaves
//               </TableCell>
//               <TableCell sx={{ px: 0 }} colSpan={2}>
//                 Emergency Leaves
//               </TableCell>
//               {/* <TableCell sx={{ px: 0 }} colSpan={1}>
//                 Edit
//               </TableCell> */}
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {employeeList.map((product, index) => (
//               <TableRow key={index} hover>
//                 <TableCell colSpan={4} align="left" sx={{ px: 0, textTransform: 'capitalize' }}>
//                   <Box display="flex" alignItems="center">
//                     <Avatar src={product.imgUrl} />
//                     <Paragraph sx={{ m: 0, ml: 4 }}>{product.name}</Paragraph>
//                   </Box>
//                 </TableCell>

//                 <TableCell align="left" colSpan={2} sx={{ px: 0, textTransform: 'capitalize' }}>
//                   ${product.price > 999 ? (product.price / 1000).toFixed(1) + 'k' : product.price}
//                 </TableCell>

//                 <TableCell sx={{ px: 0 }} align="left" colSpan={2}>
//                   {product.available ? (
//                     product.available < 20 ? (
//                       <Small bgcolor={bgSecondary}>{product.available} available</Small>
//                     ) : (
//                       <Small bgcolor={bgPrimary}>in stock</Small>
//                     )
//                   ) : (
//                     <Small bgcolor={bgError}>out of stock</Small>
//                   )}
//                 </TableCell>

//                 {/* <TableCell sx={{ px: 0 }} colSpan={1}>
//                   <IconButton>
//                     <Icon color="primary">edit</Icon>
//                   </IconButton>
//                 </TableCell> */}
//               </TableRow>
//             ))}
//           </TableBody>
//         </ProductTable>
//       </Box>
//     </Card>
//   );
// };

// const employeeList = [
//   {
//     imgUrl: '/assets/images/products/headphone-2.jpg',
//     name: 'Adinath Dhamdhere',
//     price: 100,
//     available: 15,
//   },
//   {
//     imgUrl: '/assets/images/products/headphone-3.jpg',
//     name: 'Bushra Rafia Chowdhury',
//     price: 1500,
//     available: 30,
//   },
//   {
//     imgUrl: '/assets/images/products/iphone-2.jpg',
//     name: 'Nilam Karande',
//     price: 1900,
//     available: 35,
//   },
//   {
//     imgUrl: '/assets/images/products/iphone-1.jpg',
//     name: 'Avinash Patil',
//     price: 100,
//     available: 0,
//   },
//   {
//     imgUrl: '/assets/images/products/headphone-3.jpg',
//     name: 'Nikita Gaikwad',
//     price: 1190,
//     available: 5,
//   },
// ];

// export default TopSellingTable;

import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';

const columns = [
  { field: 'username', headerName: 'Name', flex: 2 },

  { field: 'emergencyleave', headerName: 'EL', flex: 1 },
  { field: 'plannedleave', headerName: 'PL', flex: 1 },
];

export default function TopSellingTable() {
  const [rows, setRows] = useState([]);
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/annualleave`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then((response) => response.json())
      .then((data) => {
        const rowsWithId = data.map((row, index) => ({ ...row, id: index + 1 }));
        setRows(rowsWithId);
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <div style={{ }}>
      {/* Ensure Sidebar Font Size Doesn't Change */}
      <style>
        {`
          .sidebar {
            font-size: 14px !important;
          }
          .MuiDataGrid-root {
            font-size: 14px !important;
          }
        `}
      </style>

      <Typography variant="h5" style={{ marginBottom: '10px' }}>
        Employees Leave Balance [  {rows.length}   ]
      </Typography>

      <div 
        style={{
          height: 400, 
          width: "100%",
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          fontSize: '14px', // Ensures the DataGrid does not increase font size
          isolation: 'isolate', // Prevents styles from affecting sidebar
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          sx={{
            fontSize: '14px', // Prevents font size inheritance
            '& .MuiDataGrid-root': { fontSize: '14px' }, // Fixes any unexpected increases
            '& .MuiDataGrid-columnHeaders': { backgroundColor: 'rgb(100, 95, 95)', color: 'white' },
          
            '& .MuiDataGrid-cell': { textAlign: 'center' },

         
          }}
        />
      </div>
    </div>
  );
}
